import dayjs from "dayjs";
import { get } from "lodash";
import { useMemo } from "react";
import {
  MdOutlineBadge,
  MdOutlineCake,
  MdOutlineCall,
  MdOutlineLocationOn,
  MdWorkOutline,
} from "react-icons/md";
import { STEPS_KEYS } from "screens/Private/Broker/Clients/Create";
import Radio from "shared/components/Form/Radio";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { DATE_FORMAT, GENDER, PROFILE_LIST } from "utils/constants";
import { isMajor } from "utils/helpers/date";
import { bindDateInputProps, bindInputProps } from "utils/helpers/input";
export const step = { ADHERENT: "ADHERENT" };

const AMELLIS_PROFILES = [
  PROFILE_LIST.RETIRED,
  PROFILE_LIST.STUDENT,
  PROFILE_LIST.UNEMPLOYED,
  PROFILE_LIST.TEMPORARY_WORKER,
  PROFILE_LIST.EMPLOYEE,
  PROFILE_LIST.CROSS_BORDER_WORKER,
  PROFILE_LIST.TNS,
  PROFILE_LIST.LIBERAL_PROFESSION,
  PROFILE_LIST.MICRO_ENTERPRISE,
  PROFILE_LIST.TERRITORIAL_AGENT,
  PROFILE_LIST.RETIRED_TERRITORIAL_AGENT,
  PROFILE_LIST.PARTICULAR,
];

const Adherent = ({
  index,
  translation,
  values,
  setFieldValue,
  cities,
  ...formProps
}) => {
  const sortedCities = useMemo(() => {
    return [...cities].sort((a, b) =>
      a.label.localeCompare(b.label, "fr", { sensitivity: "base" }),
    );
  }, [cities]);
  return (
    <div className="contact-stepper" key={step.ADHERENT}>
      <div className="contact-stepper__header">
        <div className="contact-stepper__header--counter">
          <span>{index}</span>
        </div>
        <div className="contact-stepper__header--content">
          <h1 className="contact-stepper__header--content--title">
            <span>
              {translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].TITLE}
            </span>
          </h1>
          <p className="contact-stepper__header--content--description">
            {translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].DESCRIPTION}
          </p>
        </div>
      </div>
      <div className="contact-stepper__content">
        <Radio
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.CIVILITY
              .LABEL
          }
          options={[
            {
              label:
                translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.CIVILITY
                  .MALE,
              value: GENDER.MALE,
            },
            {
              label:
                translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.CIVILITY
                  .FEMALE,
              value: GENDER.FEMALE,
            },
          ]}
          icon={<MdOutlineBadge size={22} />}
          {...bindInputProps({
            name: "contact.user.gender",
            values,
            ...formProps,
          })}
        />
        <Input
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.LASTNAME
              .LABEL
          }
          icon={<MdOutlineBadge size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.LASTNAME
              .PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.user.lastname",
            values,
            ...formProps,
          })}
        />
        <Input
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.FIRSTNAME
              .LABEL
          }
          icon={<MdOutlineBadge size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.FIRSTNAME
              .PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.user.firstname",
            values,
            ...formProps,
          })}
        />
        <Input
          icon={<MdOutlineCake size={22} />}
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.BIRTHDAY
              .LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.BIRTHDAY
              .PLACEHOLDER
          }
          type="date"
          variant="simple"
          format={DATE_FORMAT}
          disabledDate={(current) => current > isMajor}
          defaultPickerValue={
            !get(values, "contact.user.birthDate") &&
            dayjs().subtract(30, "years")
          }
          {...bindDateInputProps({
            name: "contact.user.birthDate",
            values,
            setFieldValue,
            ...formProps,
          })}
        />
        <Input
          icon={<MdOutlineLocationOn size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .ZIPCODE.PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .ZIPCODE.LABEL
          }
          {...bindInputProps({
            name: "zipCode.value",
            values,
            ...formProps,
          })}
          onChange={({ target: { value } }) => {
            setFieldValue("zipCode.value", value);
            setFieldValue("city.value", null);
          }}
        />
        <Select
          showSearch
          options={sortedCities}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.CITY
              .PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.CITY
              .LABEL
          }
          {...bindInputProps({
            name: `city.value`,
            values,
            ...formProps,
          })}
        />
        {/* <Select
          icon={<MdOutlineHealthAndSafety size={22} />}
          options={Object.entries(SOCIAL_REGIMES).map(([key, value]) => ({
            value,
            label: translation.SOCIAL_REGIMES[key],
          }))}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .SOCIAL_REGIME.PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .SOCIAL_REGIME.LABEL
          }
          {...bindInputProps({
            name: "contact.socialRegime",
            values,
            ...formProps,
          })}
          onChange={(value) => {
            setFieldValue("contact.socialRegime", value);
            if (value !== SOCIAL_REGIMES.REGIME_SALARIES_AGRICOLES) {
              setFieldValue("contact.socioProfessionalCategory", null);
              setFieldValue("contact.exerciseFrame", null);
            }
          }}
        /> */}
        <Select
          showSearch
          icon={<MdWorkOutline size={16} />}
          options={AMELLIS_PROFILES.map((value) => ({
            label:
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .PROFILES.OPTIONS[value],
            value,
          })).sort((a, b) =>
            get(a, "label", "").localeCompare(get(b, "label", "")),
          )}
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .PROFILES.LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .PROFILES.PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.fields.profile",
            values,
            ...formProps,
          })}
          onChange={(value) => {
            setFieldValue("contact.fields.profile", value);
          }}
        />
        <Input
          icon={<MdOutlineCall size={16} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.PHONE
              .PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.PHONE
              .LABEL
          }
          {...bindInputProps({
            name: "phoneNumber.value",
            values,
            ...formProps,
          })}
        />
      </div>
    </div>
  );
};
export default Adherent;
